import find from 'lodash/find'
import { allProductsSpecificationUnits } from './UnitSelect'

export const getValueFromSchema = (metadata, schema) => {
  const inputProps = schema?.inputProps ?? {}
  let value = metadata?.value ?? ''

  //if there is options on input props it should get it's value from there
  if (inputProps?.options) {
    value = find(inputProps?.options, { value: metadata?.value })
  }

  return value
}

export const DisplayFactory = ({ schema, metadata }: any) => {
  const value = getValueFromSchema(metadata, schema)
  const unit = find(allProductsSpecificationUnits, (item) => item?.value === metadata?.unit)
  //if there is a label most probably that is the options

  return `${value?.label ?? value ?? 'Not Available'} ${unit?.label ?? ''}`
}
